














import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import KendoMultiSelect from '@/components/kendo-multiselect/kendo-multiselect.vue';
import {NameValue, NameValues} from '@/modules/neodash/model/types/interfaces/NameValue';
import {i18nMixin} from '@/modules/neodash/mixins/index';
import {IOptionalArrayTextValue} from '@/interfaces/key-value-interface';
import data from '*.json';

@Component({
  name: 'FilterMultiSelect',
  components: {
    KendoMultiSelect
  }
})
export default class FilterMultiSelect extends Vue {
  public readonly translate = i18nMixin.methods.i18n;
  public isEnabled: boolean;
  public isRequired: boolean;
  public val: IOptionalArrayTextValue<number> = null;

  @Prop({required: false})
  public value: NameValues;

  @Prop({required: false})
  public enable: boolean;

  @Prop({required: false})
  public required: boolean;

  @Prop({required: true})
  public label: string;

  @Prop({required: true})
  public dataSource: NameValues;

  @Watch('value')
  public updatePropValue() {
    this.updateValue();
  }

  @Watch('enable')
  public updateEnabled() {
    this.isEnabled = this.enable;
  }

  @Watch('required')
  public updateRequired() {
    this.isRequired = this.required;
  }

  @Watch('dataSource')
  public updateDataSource() {
    const {val, dataSource} = this;
    if (!val || !val.value || !val.value.length)
      return;

    const shouldUpdateValue =
        val.value.some(x => !dataSource.some(z => z.value === x));

    if (!shouldUpdateValue)
      return;

    const lstUpdated = dataSource.filter(x => val.value.some(z => z === x.value));

    this.val = {
      value: lstUpdated.map(x => x.value),
      text: lstUpdated.map(x => x.name)
    };
    this.propagateValue();
  }

  public created() {
    this.isEnabled = this.enable != undefined ? this.enable : true;
    this.isRequired = this.required != undefined ? this.required : true;
    this.updateValue();
  }

  public get placeholder(): string {
    if (this.isRequired)
      return this.translate('Action.Select');

    return `${this.translate('Common.All')}...`;
  }

  public propagateValue(): void {
    const value = this.val;
    if (!value || !value.text)
      return;

    const result: NameValues = value.text.map((x: string, i) => ({
      name: x,
      value: value.value[i]
    }));

    this.$emit('input', result);
    this.$emit('change', result);
  }

  private updateValue(): void {
    if (!this.value) {
      this.val = null;
      return;
    }

    this.val = {
      value: this.value.map(x => x.value),
      text: this.value.map(x => x.name)
    };
  }
}
